<script setup lang="ts">
const systemStore = useSystemStore()
const route = useRoute()
const display = useDisplay()

// 라우트 변경 감지를 위한 computed
const routeKey = computed(() => route.fullPath)

// Navigation drawer 너비 계산
const navigationWidth = computed(() => {
  if (!systemStore.adminLogin)
    return 0

  // 모바일에서는 temporary drawer이므로 너비 계산하지 않음
  if (!display.smAndUp.value)
    return 0

  // 데스크톱에서는 drawer가 열려있고 rail이 아닐 때만 전체 너비
  if (systemStore.drawer && !systemStore.rail)
    return 256

  // rail 모드이거나 drawer가 닫혀있으면 rail 너비 또는 0
  return systemStore.rail ? 56 : 0
})
// 메인 컨텐츠 스타일
const mainContentStyle = computed(() => {
  const paddingLeft = navigationWidth.value

  return {
    paddingLeft: `${paddingLeft}px`,
    transition: 'padding-left 0.2s ease-in-out',
    minHeight: '100vh',
    width: '100%',
  }
})
</script>

<template>
  <v-app>
    <AdminNavigation />
    <v-main :style="mainContentStyle">
      <v-container fluid class="pa-0">
        <div :key="routeKey">
          <slot />
        </div>
      </v-container>
    </v-main>

    <!-- 전역 다이얼로그 -->
    <GlobalDialog />
  </v-app>
</template>

<style scoped>
/* Admin 레이아웃 최적화 */
.v-main {
  transition: padding-left 0.2s ease-in-out;
}

/* 컨텐츠 영역 스크롤 최적화 */
.v-container {
  height: 100%;
  overflow-y: auto;
}
</style>
